@if (showLocationFilterDialog) {
  <loren-location-filter-dialog
  (finishSelection)="
    distanceSelected.emit($event); showLocationFilterDialog = false
  "
    [lastSelectedDistance]="lastSelectedDistance"
    >
  </loren-location-filter-dialog>
}

<div class="location-filter-btn" [style.bottom.px]="buttonBottomOffset">
  <button
    mat-fab
    class="mat-elevation-z10"
    color="accent"
    [disabled]="disabled"
    [matMenuTriggerFor]="menu"
    >
    <mat-icon>share_location</mat-icon>
  </button>
  <mat-menu #menu="matMenu" yPosition="above">
    <button mat-menu-item (click)="showLocationFilterDialog = true">
      <mat-icon>share_location</mat-icon>
      <span>{{ "operations.distance_filter_simple" | transloco }}</span>
    </button>
    @if (!isHandset) {
      <button
        mat-menu-item
        [disabled]="lastSelectedDistance === null"
        (click)="exportTraceStopsDistanceReport.emit()"
        >
        <mat-icon>analytics</mat-icon>
        <span>{{ "operations.download_data" | transloco }}</span>
      </button>
    }
    <button
      mat-menu-item
      [disabled]="lastSelectedDistance === null"
      (click)="lastSelectedDistance = null; distanceSelected.emit(null)"
      >
      <mat-icon>cancel</mat-icon>
      <span>{{ "operations.cancel" | transloco }}</span>
    </button>
  </mat-menu>
</div>
